"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _tooltipFlyout = _interopRequireDefault(require("@site/pattern-library-core/tooltip-flyout"));
var _configContext = require("../context/config-context");
var _bulletList = _interopRequireDefault(require("./bullet-list"));
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-ch5dzmr"
});
const TitleContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleContainer",
  class: "pc-t21ojba"
});
const StyledTooltipFlyout = /*#__PURE__*/(0, _react2.styled)(_tooltipFlyout.default)({
  name: "StyledTooltipFlyout",
  class: "pc-s17mlllh"
});

/**
 * ProductContent Component
 *
 * @param {Object} props props
 * @param {string} props.title Title of the product
 * @param {string} props.description Dscription of the product
 * @param {Object} props.flyout Flyout Tooltip component for the product
 * @param {string} props.sharedTagLabel Label for the product tag
 * @param {string} props.dataCy data-cy attribute value
 * @param {string} props.secondaryTitle secondaryTitle
 * @param {object} props.image Image object
 * @returns {React.ReactElement} ProductContent Component
 * @public
 */
// eslint-disable-next-line complexity
function ProductContent({
  title,
  description,
  list,
  flyout,
  productTagLabel,
  sharedTagLabel,
  dataCy = 'product',
  secondaryTitle,
  image,
  titleSize = 1
}) {
  const {
    asModal
  } = (0, _configContext.useConfig)() || {};
  if (!title) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": `${dataCy}-product`,
    className: "product-content"
  }, sharedTagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    dataCy: `${dataCy}-tag`,
    className: "tag",
    text: sharedTagLabel,
    design: "highlight",
    size: "sm"
  }), /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-title`,
    as: "title",
    text: title,
    size: titleSize
  }), flyout && Object.keys(flyout).length > 0 && /*#__PURE__*/_react.default.createElement(StyledTooltipFlyout, (0, _extends2.default)({}, flyout, {
    className: asModal ? 'in-modal' : ''
  })), productTagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    dataCy: `${dataCy}-tag`,
    text: productTagLabel,
    design: "highlight",
    size: "sm"
  })), description && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-description`,
    as: "paragraph",
    size: -1,
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(description)
    }
  }), list && list.length > 0 && /*#__PURE__*/_react.default.createElement(_bulletList.default, {
    list: list,
    dataCy: dataCy
  }), secondaryTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-secondary-title`,
    as: "title",
    text: secondaryTitle,
    size: -1
  }), image && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    dataCy: 'attachment-image',
    url: image?.url,
    altText: image?.altText,
    height: image?.height,
    width: image?.width
  }));
}
var _default = exports.default = ProductContent;
ProductContent.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  list: _propTypes.default.array,
  flyout: _propTypes.default.object,
  sharedTagLabel: _propTypes.default.string,
  productTagLabel: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  secondaryTitle: _propTypes.default.string,
  image: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string,
    height: _propTypes.default.string,
    width: _propTypes.default.string
  }),
  titleSize: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6])
};